<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="LIA" :icon="require('@/assets/admin-icon/assignment-active.svg')">
        <div class="options">
          <widgetButton :loading="false" @click="addInternship()" class="btn-primary">
            {{
              filter_form.status == "private"
                ? "Create Private Lia +"
                : "Create Lia +"
            }}
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>

    <div class="page-body">
      <div class="company-profile-wrapper">
        <!-- company-profile display -->
        <div class="company-profile-container">
          <div class="assignment-widget">
            <multipane class="custom-resizer" layout="vertical">
              <div class="left-panel">
                <!-- Internal Lia -->
                <div class="internship-widget">
                  <div class="internship-widget-header">
                    <div class="internship-widget-top-header">
                      <div class="internship-widget-header-title">
                        <input @change="onSelectAll" class="checkbox" type="checkbox" />
                        <label class="label-title">{{
                          internship_data
                            ? "Internal LIA (" + internship_data.total + ")"
                            : "Internal LIA"
                          }}</label>
                      </div>
                      <!-- Filter Internal Lia options -->
                      <div class="internship-widget-header-filter-options">
                        <widgetDropdown v-if="show_selected_options" v-model="internal_list_dropdown" :right="true"
                          :hover="false" :interactive="true" class="selected-dropdown">
                          <button class="btn-dropdown">
                            <img class="icon" style="height: 20px" src="@/assets/icon/menu-dot.svg" />
                          </button>
                          <div slot="dropdown" class="dropdown-widget right">
                            <app-dialog v-if="filter_form.status == 'active'" title="Move LIA to archive"
                              ask="Are you sure you want to move this LIA to archive?" yesText="Yes" noText="No"
                              @onComfirm="moveToArchiveSelectedLia()">
                              <a class="dropdown-item" href="#">Move To Archive</a>
                            </app-dialog>
                            <a class="dropdown-item" href="#" @click="exportAllLia()">Export LIA</a>
                            <app-dialog title="Delete LIA" ask="Are you sure you want to delete All Selected LIA?"
                              yesText="Yes" noText="No" @onComfirm="deleteSelectedLia()">
                              <a class="dropdown-item" href="#">Delete</a>
                            </app-dialog>
                          </div>
                        </widgetDropdown>
                        <button class="btn-clear-filter" v-if="isFilteringIntern" @click="clearAllFilters()">
                          Clear Filters
                        </button>
                      </div>
                    </div>

                    <!-- Tabs -->
                    <div class="internship-tabs-widget">
                      <widgetTabs :tabs="[
                        {
                          title: 'All',
                          value: 'all',
                        },
                        {
                          title: 'Public',
                          value: 'active',
                        },
                        {
                          title: 'Private',
                          value: 'private',
                        },
                        {
                          title: 'Archive',
                          value: 'archive',
                        },
                      ]" @change="onChangeInternalLiaTab"></widgetTabs>
                    </div>
                    <!-- Filter Internal Lia form-->
                    <div class="filter-widget">
                      <div class="lia-search-widget">
                        <widgetSearch icon="right" style="width: 100%" v-model="internal_intern_search_input"
                          @keyup="searchInternship" placeholder="Search LIA"></widgetSearch>
                        <div class="h-spacer"></div>
                        <map-helper class="location-input" type="lia" @onSubmit="onFilterByLocation"
                          placeholder="Search LIA by location" style="width: 100%" v-model="location_name">
                        </map-helper>
                      </div>
                      <div class="filter-inputs">
                        <div class="filter-header">
                          <button class="btn-filter" @click="
                            showInternalLiaFilter = !showInternalLiaFilter
                            ">
                            <img class="left-icon" src="@/assets/admin-icon/filter.svg" />
                            Filter
                            <img class="right-icon" v-if="showInternalLiaFilter"
                              src="@/assets/admin-icon/gray-caret-up.svg" />
                            <img class="right-icon" v-else src="@/assets/admin-icon/gray-caret-down.svg" />
                          </button>
                          <div class="h-line"></div>
                        </div>
                        <div class="filter-body" v-if="showInternalLiaFilter">
                          <div class="tag-filter-input">
                            <widgetDropdown v-model="tags_input_filter" :hover="false" :interactive="true"
                              :closeOnClickOutside="true">
                              <button class="btn-dropdown">
                                Tags
                                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                              </button>
                              <div slot="dropdown">
                                <widgetListSelecter v-model="tags_filter" @close="tags_input_filter = false"
                                  @confirm="filterByTag">
                                </widgetListSelecter>
                              </div>
                            </widgetDropdown>
                          </div>
                          <div class="h-spacer"></div>
                          <div class="worktype-filter-input">
                            <widgetDropdown v-model="show_worktype_filter" :right="true" :hover="false"
                              :interactive="true">
                              <button class="btn-dropdown">
                                LIA type
                                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                              </button>
                              <div slot="dropdown">
                                <widgetListSelecter v-model="worktype_filter" :showSearch="false"
                                  @close="show_worktype_filter = false" @confirm="onSearchInternalInternshipByWorktype
                                    ">
                                </widgetListSelecter>
                              </div>
                            </widgetDropdown>
                          </div>
                        </div>
                        <div class="worktype-filter" v-if="filter_form.status != 'private'">
                          <widgetCheckbox title="No student interested" v-model="internal_intern_filter_not_interested_input
                            " @change="onSearchInternalInternshipByNotInterested"></widgetCheckbox>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Lia items -->
                  <div class="internship-widget-body" :class="{ filter_enabled: showInternalLiaFilter }"
                    v-if="internship_data && internship_data.data.length > 0" @scroll="onInternshipScoll">
                    <internshipItem v-for="(item, index) in internship_data.data" :item="item" :key="index"
                      :index="index" :class="{ active: false }" :show_option="true" :isCheckBox="true"
                      :isInArchive="filter_form.status == 'archive'" :tab_section="filter_form.status" type="school"
                      @update="updateInternship" @delete="deleteInternship" @checked="itemChecked($event, index)"
                      @move-to-archive="
                        onInternshipMoveToArchive($event, index, 'internal')
                        " @assignTo="onAssignTo($event, index)">
                    </internshipItem>

                    <div class="loading-paginated-items" v-if="internal_internship_loading">
                      <loading :height="15" color="#1ba5a4" :opacity="1" :width="15"
                        :active.sync="internal_internship_loading" :is-full-page="false" :can-cancel="false"
                        background-color="#fff" class="loader"></loading>
                    </div>
                  </div>
                  <!-- Loading Lia -->
                  <div class="internship-widget-body" v-if="internal_internship_loading && !internship_data">
                    <loading :height="15" color="#1ba5a4" :opacity="1" :width="15"
                      :active.sync="internal_internship_loading" :is-full-page="false" :can-cancel="false"
                      background-color="#fff" class="loader"></loading>
                  </div>
                  <!-- When lia not found -->
                  <div class="empty-widget" v-if="(!internal_internship_loading &&
                    internship_data &&
                    internship_data.data.length == 0) ||
                    (!internal_internship_loading && !internship_data)
                  ">
                    <div class="empty-widget-body">
                      <widgetNotFoundWidget title="No LIA Found" content="You do not have any LIA yet" :btntext="filter_form.status == 'private'
                        ? 'Create Private Lia +'
                        : 'Create Lia +'
                        " @click="addInternship()">
                        <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
                      </widgetNotFoundWidget>
                    </div>
                  </div>
                </div>
              </div>
              <multipane-resizer></multipane-resizer>

              <div class="right-panel">
                <!-- Extenal Lia -->
                <div class="internship-widget">
                  <div class="internship-widget-header">
                    <div class="internship-widget-top-header">
                      <div class="internship-widget-header-title">
                        <label class="label-title">{{
                          public_internships
                            ? "Extenal LIA (" + public_internships.total + ")"
                            : "Extenal LIA"
                          }}</label>
                      </div>
                      <!-- Filter Extenal Lia options -->
                      <div class="internship-widget-header-filter-options">
                        <button class="btn-clear-filter" v-if="isExtenalFilteringIntern"
                          @click="clearExtenalInternshipFilters()">
                          Clear Filters
                        </button>
                      </div>
                    </div>
                    <!-- Tabs -->
                    <div class="internship-tabs-widget">
                      <widgetTabs :tabs="[
                        {
                          title: 'All',
                          value: 'all',
                        },
                        {
                          title: 'Active',
                          value: 'active',
                        },
                        {
                          title: 'Archive',
                          value: 'archive',
                        },
                      ]" @change="onChangeExernalLiaTab"></widgetTabs>
                    </div>
                    <!-- Filter Extenal Lia form-->
                    <div class="filter-widget">
                      <div class="search-widget">
                        <widgetSearch icon="left" v-model="extenal_internship_filter_form.text"
                          @keyup="searchExtenalInternship" placeholder="Type in to Search…"></widgetSearch>
                      </div>
                      <div class="filter-inputs">
                        <div class="filter-header">
                          <button class="btn-filter" @click="
                            showExtenalLiaFilter = !showExtenalLiaFilter
                            ">
                            <img class="left-icon" src="@/assets/admin-icon/filter.svg" />
                            Filter
                            <img class="right-icon" v-if="showExtenalLiaFilter"
                              src="@/assets/admin-icon/gray-caret-up.svg" />
                            <img class="right-icon" v-else src="@/assets/admin-icon/gray-caret-down.svg" />
                          </button>
                          <div class="worktype-filter" v-if="showExtenalLiaFilter">
                            <widgetCheckbox title="Onsite" v-model="extenal_intern_filter_worktype_onsite_input
                              " @change="
                                onSearchExtenalInternshipByWorktype(
                                  $event,
                                  'onsite'
                                )
                                "></widgetCheckbox>
                            <div class="h-spacer"></div>
                            <widgetCheckbox title="Remote" v-model="extenal_intern_filter_worktype_remote_input
                              " @change="
                                onSearchExtenalInternshipByWorktype(
                                  $event,
                                  'remote'
                                )
                                "></widgetCheckbox>
                          </div>
                        </div>
                        <div class="filter-body" v-if="showExtenalLiaFilter">
                          <map-helper class="location-input" type="lia" @onSubmit="onFilterExtenalInternshipByLocation"
                            placeholder="Filter by location" style="width: 200px" v-model="extenal_internship_location">
                          </map-helper>
                          <div class="h-spacer"></div>
                          <div class="tag-filter-input">
                            <widgetDropdown v-model="extenal_internship_tags_input_filter" :right="true" :hover="false"
                              :interactive="true">
                              <button class="btn-dropdown">
                                Tags
                                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                              </button>
                              <div slot="dropdown" class="dropdown-widget right">
                                <widgetListSelecter v-model="tags_filter" @close="
                                  extenal_internship_tags_input_filter = false
                                  " @confirm="filterExtenalInternshipByTag">
                                </widgetListSelecter>
                              </div>
                            </widgetDropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Lia items -->
                  <div class="internship-widget-body" :class="{ filter_enabled: showExtenalLiaFilter }" v-if="public_internships && public_internships.data.length > 0
                  " @scroll="onExtenalInternshipScoll">
                    <internshipItem v-for="(item, index) in public_internships.data" :item="item" :key="index"
                      :index="index" :class="{ active: false }" :show_option="false" :isCheckBox="false" :isInArchive="extenal_internship_filter_form.status == 'archive'
                        " type="company">
                    </internshipItem>

                    <div class="loading-paginated-items" v-if="showExtenalInternshipLoading">
                      <loading :height="15" color="#1ba5a4" :opacity="1" :width="15"
                        :active.sync="showExtenalInternshipLoading" :is-full-page="false" :can-cancel="false"
                        background-color="#fff" class="loader"></loading>
                    </div>
                  </div>
                  <!-- Loading Lia -->
                  <div class="internship-widget-body" v-if="showExtenalInternshipLoading || !public_internships">
                    <loading :height="15" color="#1ba5a4" :opacity="1" :width="15"
                      :active.sync="showExtenalInternshipLoading" :is-full-page="false" :can-cancel="false"
                      background-color="#fff" class="loader"></loading>
                  </div>
                  <!-- When lia not found -->
                  <div class="empty-widget" v-if="(!showExtenalInternshipLoading &&
                    public_internships &&
                    public_internships.data.length == 0) ||
                    (!public_internships && !showExtenalInternshipLoading)
                  ">
                    <div class="empty-widget-body">
                      <widgetNotFoundWidget title="No LIA Found" content="We don't have any public LIA yet">
                        <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
                      </widgetNotFoundWidget>
                    </div>
                  </div>
                </div>
              </div>
            </multipane>
          </div>
        </div>
        <!-- End -->
      </div>
    </div>

    <!-- Create Interneship Modal -->
    <addInternshipModal v-if="show_internship_modal" :content="selected_internship" type="normal" :account_data="{
      type: 'single',
      accounts: null,
    }" :add_accounts="true" @success="onSuccessCreateInternship" @close="show_internship_modal = false">
    </addInternshipModal>

    <!-- Assign modal -->
    <assignInternshipModal v-if="show_assign_modal" :internship="selected_internship" @close="show_assign_modal = false"
      @success="onSuccessAssignInternship"></assignInternshipModal>

    <!-- Add private LIA -->
    <!-- Add new private lia  -->
    <addPrivateInternshipModal v-if="show_add_new_private_lia_modal" :content="selected_internship"
      @success="onSuccessCreateInternship" @close="show_add_new_private_lia_modal = false"></addPrivateInternshipModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import addInternshipModal from "@/views/internship/components/add_internship_modal.vue";
import internshipItem from "@/views/internship/components/internship_item.vue";
import assignInternshipModal from "@/views/internship/components/assign_internship_modal.vue";
import addPrivateInternshipModal from "./components/add_private_internship_modal.vue";
export default {
  name: "Assignment",
  components: {
    addInternshipModal,
    internshipItem,
    assignInternshipModal,
    addPrivateInternshipModal,
  },
  props: {},
  data: () => {
    return {
      show_add_new_private_lia_modal: false,
      show_menu: false,
      internal_internship_loading: false,
      tags_input_filter: false,
      selected_internship: null,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        projects: [],
      },
      showExtenalInternshipLoading: false,
      show_internship_modal: false,
      internship_loading: false,
      internship_data: null,
      public_internships: null,
      tags_input: "",
      tags_filter: [],
      filter_type: "none",
      filter_data: null,
      internal_list_dropdown: false,
      show_selected_options: null,
      isAllInternshipSelected: false,
      filter_form: {
        status: "all",
        text: "",
        location: "",
        worktype: [],
        tags: [],
        not_interested: false,
        url_type: "",
        next_page_url: "",
      },
      location_name: "",
      internal_intern_search_input: "",
      showInternalLiaFilter: false,
      internal_intern_filter_not_interested_input: false,
      extenal_internship_filter_form: {
        status: "all",
        text: "",
        location: "",
        worktype: [],
        tags: [],
        url_type: "",
        next_page_url: "",
      },
      showExtenalLiaFilter: false,
      extenal_internship_tags_input_filter: false,
      extenal_internship_tags_filter: [],
      extenal_internship_location: "",
      extenal_intern_filter_worktype_onsite_input: false,
      extenal_intern_filter_worktype_remote_input: false,
      show_assign_modal: false,
      show_worktype_filter: false,
      worktype_filter: [
        { name: "Flexible", value: "flexible" },
        { name: "Hybrid", value: "hybrid" },
        { name: "On Site", value: "onsite" },
        { name: "Remote", value: "remote" },
      ],
    };
  },
  mounted() {
    let vm = this;
    vm.getInternalInternship();
    vm.getPublicInternships();
    vm.getTags();
  },
  computed: {
    isFilteringIntern() {
      let vm = this;
      return (
        vm.filter_form.text.length > 0 ||
        vm.filter_form.location.length > 0 ||
        vm.filter_form.tags.length > 0 ||
        vm.filter_form.worktype.length > 0 ||
        vm.internal_intern_filter_not_interested_input
      );
    },
    isExtenalFilteringIntern() {
      let vm = this;
      return (
        vm.extenal_internship_filter_form.text.length > 0 ||
        vm.extenal_internship_filter_form.location.length > 0 ||
        vm.extenal_internship_filter_form.tags.length > 0 ||
        vm.extenal_intern_filter_worktype_onsite_input ||
        vm.extenal_intern_filter_worktype_remote_input
      );
    },
  },
  methods: {
    onSuccessAssignInternship() {
      let vm = this;
      vm.show_assign_modal = false;
    },
    onAssignTo(item, index) {
      let vm = this;
      vm.selected_internship = item;
      vm.show_assign_modal = true;
    },
    onInternshipMoveToArchive(item, index, type) {
      let vm = this;
      vm.$store
        .dispatch("INTERNSHIP_MOVE_TO_ARCHIVE", { id: item.id, type: type })
        .then((responce) => {
          vm.internship_data.data.splice(index, 1);
          vm.$notify({
            group: "status",
            title: "Message",
            text: "LIA is now archived",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    // Internal Internship functions
    onChangeInternalLiaTab({ value }) {
      let vm = this;
      vm.filter_form.status = value;
      vm.getInternalInternship();
    },
    onSelectAll({ target }) {
      let vm = this;
      vm.isAllInternshipSelected = target.checked;
      if (target.checked) {
        vm.internship_data.data = vm.internship_data.data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.internship_data.data = vm.internship_data.data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateChecked();
    },
    itemChecked($event, index) {
      let vm = this;
      vm.isAllInternshipSelected = false;
      vm.internship_data.data[index].checked = $event.checked;
      vm.validateChecked();
    },
    validateChecked(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_options =
          vm.internship_data.data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      if (type == "ids") {
        return vm.internship_data.data
          .filter((item) => item.checked == true)
          .map((item) => item.id);
      }
      return vm.internship_data.data
        .filter((item) => item.checked == true)
        .map((item) => item);
    },
    exportAllLia() {
      let vm = this;
      vm.internal_list_dropdown = false;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("INTERNSHIP_EXPORT_INTERNAL_LIA", {
          all: vm.isAllInternshipSelected,
          ids: ids.map((item) => item.id),
          filters: vm.filter_form,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "lia.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    deleteSelectedLia() {
      let vm = this;
      vm.internal_list_dropdown = false;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("INTERNSHIP_DELETE_SELECTED_LIA", {
          all: vm.isAllInternshipSelected,
          ids: ids.map((item) => item.id),
          filters: vm.filter_form,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Selected LIA deleted successfully",
            type: "success",
            duration: 3000,
          });
          vm.getInternalInternship();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    moveToArchiveSelectedLia() {
      let vm = this;
      vm.internal_list_dropdown = false;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("INTERNSHIP_MOVE_ARCHIVE_SELECTED_LIA", {
          all: vm.isAllInternshipSelected,
          ids: ids.map((item) => item.id),
          filters: vm.filter_form,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Selected LIA moved to archive successfully",
            type: "success",
            duration: 3000,
          });
          vm.getInternalInternship();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    deleteInternship(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_DELETE_COMPANY_INTERNSHIP", { id: item.id })
        .then((responce) => {
          vm.getInternalInternship();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "LIA is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    updateInternship(item) {
      let vm = this;
      vm.selected_internship = item;
      if (vm.filter_form.status == "private" || item.status == 1) {
        vm.show_add_new_private_lia_modal = true;
      } else {
        vm.show_internship_modal = true;
      }
    },
    onSuccessCreateInternship() {
      let vm = this;
      if (vm.filter_form.status == "private") {
        vm.show_add_new_private_lia_modal = false;
      } else {
        vm.show_internship_modal = false;
      }
      vm.getInternalInternship();
    },
    addInternship() {
      let vm = this;
      vm.selected_internship = null;
      if (vm.filter_form.status == "private") {
        vm.show_add_new_private_lia_modal = true;
      } else {
        vm.show_internship_modal = true;
      }
    },
    clearAllFilters() {
      let vm = this;
      vm.filter_form = {
        status: vm.filter_form.status,
        text: "",
        location: "",
        tags: [],
        worktype: [],
        not_interested: false,
        url_type: "",
        next_page_url: "",
      };
      eventBus.$emit("reset_filter");
      vm.tags_filter = [];
      vm.location_name = "";
      vm.internal_intern_filter_not_interested_input = false;
      vm.internal_intern_search_input = "";
      vm.getTags();
      vm.getInternalInternship();
    },
    onSearchInternalInternshipByNotInterested({ target }) {
      let vm = this;
      vm.filter_form.not_interested = target.checked;
      vm.getInternalInternship();
    },
    onSearchInternalInternshipByWorktype(data) {
      let vm = this;
      vm.show_worktype_filter = false;
      vm.filter_form.worktype = [];
      data.forEach((type) => {
        if (type == "onsite") {
          [type, "On site", "on site", "On Site", "Onsite", "onsite"].forEach(
            (it) => {
              vm.filter_form.worktype.push(it);
            }
          );
        } else if (type == "remote") {
          [type, "Remote"].forEach((it) => {
            vm.filter_form.worktype.push(it);
          });
        } else if (type == "hybrid") {
          [type, "Hybrid"].forEach((it) => {
            vm.filter_form.worktype.push(it);
          });
        } else if (type == "flexible") {
          [type, "Flexible"].forEach((it) => {
            vm.filter_form.worktype.push(it);
          });
        }
      });
      vm.getInternalInternship();
    },
    searchInternship({ target }) {
      let vm = this;
      vm.filter_form.text = target.value;
      vm.internal_internship_loading = true;
      vm.getInternalInternship("init");
    },
    filterByTag(data) {
      let vm = this;
      vm.tags_input_filter = false;
      vm.filter_form.tags = data;
      vm.getInternalInternship("init");
    },
    onFilterByLocation(data) {
      let vm = this;
      vm.filter_form.location = data.name;
      vm.getInternalInternship("init");
    },
    getInternalInternship(type = "init") {
      let vm = this;
      vm.internal_internship_loading = true;
      if (type == "init") {
        vm.internship_data = null;
      }
      vm.filter_form.url_type = type;
      vm.filter_form.next_page_url = vm.internship_data
        ? vm.internship_data.next_page_url
        : "";
      vm.$store
        .dispatch("INSTRUCTOR_GET_ALL_INTERNSHIP", vm.filter_form)
        .then((responce) => {
          vm.internal_internship_loading = false;
          responce.data.data = responce.data.data.map((item, index) => {
            if (vm.isAllInternshipSelected) {
              eventBus.$set(item, "checked", true);
            } else {
              eventBus.$set(item, "checked", false);
            }
            eventBus.$set(item, "expand_student", false);
            if (index == 0 && type == "init") {
              eventBus.$set(item, "expanded", true);
            } else {
              eventBus.$set(item, "expanded", false);
            }
            return item;
          });
          if (type == "init") {
            vm.internship_data = responce.data;
          } else {
            vm.internship_data.next_page_url = responce.data.next_page_url;
            vm.internship_data.current_page = responce.data.current_page;
            vm.internship_data.last_page = responce.data.last_page;
            responce.data.data.forEach((item) => {
              vm.internship_data.data.push(item);
            });
          }
        })
        .catch((error) => { });
    },
    onInternshipScoll({ target }) {
      let vm = this;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (
          !vm.internal_internship_loading &&
          vm.internship_data.current_page < vm.internship_data.last_page
        ) {
          vm.getInternalInternship("next");
        }
      }
    },
    searchPublicInternship({ target }) {
      let vm = this;
      vm.$store
        .dispatch("SEARCH_PUBLIC_INTERNSHIP", { query: target.value })
        .then((responce) => {
          vm.public_internships = responce.data.map((item, index) => {
            eventBus.$set(item, "checked", false);
            eventBus.$set(item, "expand_student", false);
            if (index == 0) {
              eventBus.$set(item, "expanded", true);
            } else {
              eventBus.$set(item, "expanded", false);
            }
            return item;
          });
        })
        .catch((error) => { });
    },
    removeInternshipToStudent(user_id, internship_id) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_REMOVED_COMPANY_INTERNSHIP_TO_STUDENT", {
          id: internship_id,
          user_id: user_id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "LIA is now removed to student",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    unpublish(id) {
      let vm = this;
      vm.$store
        .dispatch("UNPUBLISH_ASSIGNMENT", { id: id })
        .then((response) => {
          vm.getAssignment();
          vm.getAllStartData();
          vm.getOurAssingment();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    publish(id) {
      let vm = this;
      vm.$store
        .dispatch("PUBLISH_ASSIGNMENT", { id: id })
        .then((response) => {
          vm.getAssignment();
          vm.getAllStartData();
          vm.getOurAssingment();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTags() {
      let vm = this;
      vm.$store
        .dispatch("INTERNSHIP_GET_TAGS")
        .then((response) => {
          vm.tags_filter = response.data.map((item) => {
            return {
              value: item.name,
              name: item.name,
            };
          });
        })
        .catch((error) => { });
    },
    // Extenal internship functions
    onChangeExernalLiaTab({ value }) {
      let vm = this;
      vm.extenal_internship_filter_form.status = value;
      vm.getExternalInternship();
    },
    clearExtenalInternshipFilters() {
      let vm = this;
      vm.extenal_internship_filter_form = {
        status: vm.extenal_internship_filter_form.status,
        text: "",
        tags: [],
        location: "",
        worktype: [],
        url_type: "",
        next_page_url: "",
      };
      vm.extenal_internship_location = "";
      vm.extenal_intern_filter_worktype_onsite_input = false;
      vm.extenal_intern_filter_worktype_remote_input = false;
      vm.getPublicInternships("init");
    },
    onExtenalInternshipScoll({ target }) {
      let vm = this;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (
          !vm.showExtenalInternshipLoading &&
          vm.public_internships.current_page < vm.public_internships.last_page
        ) {
          vm.getPublicInternships("next");
        }
      }
    },
    getPublicInternships(type = "init") {
      let vm = this;
      vm.showExtenalInternshipLoading = true;
      if (type == "init") {
        vm.public_internships = null;
      }
      vm.extenal_internship_filter_form.url_type = type;
      vm.extenal_internship_filter_form.next_page_url = vm.public_internships
        ? vm.public_internships.next_page_url
        : "";
      vm.$store
        .dispatch(
          "INSTRUCTOR_GET_PUBLIC_INTERNSHIP",
          vm.extenal_internship_filter_form
        )
        .then((responce) => {
          vm.showExtenalInternshipLoading = false;
          responce.data.data = responce.data.data.map((item, index) => {
            eventBus.$set(item, "checked", false);
            eventBus.$set(item, "expand_student", false);
            if (index == 0 && type == "init") {
              eventBus.$set(item, "expanded", true);
            } else {
              eventBus.$set(item, "expanded", false);
            }
            return item;
          });
          if (type == "init") {
            vm.public_internships = responce.data;
          } else {
            vm.public_internships.next_page_url = responce.data.next_page_url;
            vm.public_internships.current_page = responce.data.current_page;
            vm.public_internships.last_page = responce.data.last_page;
            responce.data.data.forEach((item) => {
              vm.public_internships.data.push(item);
            });
          }
        })
        .catch((error) => {
          vm.showExtenalInternshipLoading = false;
        });
    },
    searchExtenalInternship() {
      let vm = this;
      vm.getPublicInternships("init");
    },
    onSearchExtenalInternshipByWorktype({ target }, type) {
      let vm = this;
      if (target.checked) {
        if (type == "onsite") {
          [type, "On site", "on site", "On Site", "Onsite"].forEach((it) => {
            vm.extenal_internship_filter_form.worktype.push(it);
          });
        } else {
          vm.extenal_internship_filter_form.worktype.push(type);
        }
      } else {
        if (type == "onsite") {
          [type, "On site", "on site", "On Site", "Onsite"].forEach((it) => {
            if (vm.extenal_internship_filter_form.worktype.indexOf(it) > -1) {
              vm.extenal_internship_filter_form.worktype.splice(
                vm.extenal_internship_filter_form.worktype.indexOf(it),
                1
              );
            }
          });
        } else {
          if (vm.extenal_internship_filter_form.worktype.indexOf(type) > -1) {
            vm.extenal_internship_filter_form.worktype.splice(
              vm.extenal_internship_filter_form.worktype.indexOf(type),
              1
            );
          }
        }
      }
      vm.getPublicInternships("init");
    },
    onFilterExtenalInternshipByLocation(data) {
      let vm = this;
      vm.extenal_internship_filter_form.location = data.name;
      vm.getPublicInternships("init");
    },
    filterExtenalInternshipByTag(data) {
      let vm = this;
      vm.extenal_internship_tags_input_filter = false;
      vm.extenal_internship_filter_form.tags = data;
      vm.getInternalInternship("init");
    },
  },
  watch: {
    tag_filter_data(val) {
      let vm = this;
      vm.filterByTag(val);
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
        height: 45px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-body {
    height: calc(100% - 43px);
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .company-profile-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .company-profile-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .assignment-widget {
          height: 100%;
          width: 100%;
          position: relative;
          display: flex;
          flex-direction: column;

          .custom-resizer {
            height: 100%;

            .multipane-resizer {
              width: 10px !important;

              &::before {
                top: 0px !important;
                height: calc(100% - 20px) !important;
              }
            }
          }

          .left-panel {
            height: 100%;
            width: 50%;
            min-width: 40%;
            max-width: 50%;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
          }

          .right-panel {
            height: 100%;
            min-width: 40%;
            width: 50%;
            border-radius: 5px;
            display: flex;
            flex-grow: 1;
            flex-direction: column;
          }

          .internship-widget {
            display: flex;
            flex-direction: column;
            height: 100%;

            .internship-widget-header {
              border-radius: 5px;
              padding: 0px 8px;
              padding-top: 8px;
              height: max-content;
              width: 100%;
              margin-bottom: 5px;
              transition: 600ms ease-in-out;
              background: #fff;
              border-radius: 5px;
              display: flex;
              flex-direction: column;

              .internship-widget-top-header {
                display: flex;
                justify-content: space-between;
                margin-top: 0px;
                width: 100%;

                .internship-widget-header-title {
                  .label-title {
                    font-family: "Nunito";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                  }
                }

                .internship-widget-header-filter-options {
                  display: flex;
                  align-items: center;
                }
              }

              .internship-tabs-widget {
                margin: 3px 0px;
              }

              .filter-widget {
                padding: 3px 0px;
                max-width: 500px;

                .lia-search-widget {
                  display: flex;
                }

                .filter-inputs {
                  margin-top: 8px;

                  .filter-header {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;

                    .btn-filter {
                      display: flex;
                      align-items: center;
                      padding: 0px 0px;
                      margin-right: 7px;

                      .left-icon {
                        margin-right: 5px;
                      }

                      .right-icon {
                        width: 12px;
                        margin-left: 5px;
                      }
                    }

                    .h-line {
                      width: 100%;
                      height: 1px;
                      background: #656565;
                      margin: 0px 0px;
                    }
                  }

                  .filter-body {
                    display: flex;
                    width: 100%;
                    margin-bottom: 15px;

                    .location-input {
                      width: 50% !important;
                    }

                    .tag-filter-input,
                    .worktype-filter-input {
                      width: 50%;

                      .dropdown {
                        width: 100%;

                        .btn-dropdown {
                          width: 100%;
                          height: 30px;
                          border-radius: 5px;
                          background: #fff;
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          cursor: pointer;
                          border: 1px solid rgb(232, 232, 232);
                          padding: 0px 10px;
                        }
                      }
                    }
                  }

                  .worktype-filter {
                    display: flex;
                    align-items: center;
                  }
                }
              }
            }

            .internship-widget-body {
              height: calc(100% - 145px);
              display: flex;
              flex-direction: column;
              border-radius: 5px;
              overflow-y: auto;
              position: relative;

              &.filter_enabled {
                height: calc(100% - 190px);
              }

              .loading-paginated-items {
                height: 150px;
                background: #fff;
                position: relative;
                padding: 10px;
                border-radius: 5px;
                margin-bottom: 20px;
                margin-top: 20px;
              }
            }

            .empty-widget {
              background: #fff;
              padding: 20px;
              border-radius: 5px;
              height: calc(100% - 145px);

              &.filter_enabled {
                height: calc(100% - 190px);
              }

              .empty-widget-body {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
              }
            }
          }
        }
      }
    }
  }
}
</style>